export default __webpack_public_path__ + "static/media/oscer-pres-red-eye.b8be721a.svg";